export const normalizeFields = ['__typename', 'editing', 'selected', 'entityMetaData'];

//This takes an object (or array) and strips out fields that are temporary or not expected by mutations in the services (e.g. __typename).
//The types are expected to be the query type (I.e. ISalesOrder) and 'input' type for a mutation (I.e. ISalesOrderInput) and are available for convenience.
const normalizeVariables = <Type = any, TypeInput = Type>(
  value: Type,
  removeFields: string[] = normalizeFields
): TypeInput => {
  if (value === null || value === undefined) {
    return value as unknown as TypeInput;
  } else if (Array.isArray(value)) {
    return value.map((v) => normalizeVariables(v, removeFields)) as any;
  } else if (typeof value === 'object') {
    const newObj: any = {};
    Object.entries(value).forEach(([key, v]) => {
      if (removeFields.indexOf(key) === -1) {
        newObj[key] = normalizeVariables(v, removeFields);
      }
    });

    if (newObj.id && `${newObj.id}`.startsWith('new_')) {
      delete newObj.id;
    }
    if (newObj.notes && Array.isArray(newObj.notes)) {
      //Strip empty notes.
      newObj.notes = newObj.notes.filter((note: any) => note.text);
    }
    return newObj;
  }
  return value as unknown as TypeInput;
};

export default normalizeVariables;
